import { render } from "./car-comparison-component.vue?vue&type=template&id=16b7edbc"
import script from "./car-comparison-component.vue?vue&type=script&lang=js"
export * from "./car-comparison-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__